import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { routing } from './zone.routing';
import { ZoneComponent } from './zone.component';
@NgModule({
    imports: [
        CommonModule,
        routing,
    ],
    declarations: [
        ZoneComponent,
    ]
})

export class ZoneModule {}